import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'

/**
 * Mounts the WpPageTemplate review + adjust Vue component (SP2 Task 10).
 * The component itself owns data-fetching (GET show), slot editing
 * (PATCH slots), approval (POST approve), and the ActionCable
 * subscription for live extraction progress -- this controller's only
 * job is the ERB -> Vue mount/unmount bridge.
 */
export default class extends Controller {
  static targets = ['loading']

  static values = {
    templateId: String,
    csrfToken: String
  }

  connect() {
    this.vueApp = null
    this.mountVue()
  }

  disconnect() {
    this.unmountVue()
  }

  async mountVue() {
    if (this.vueApp) return

    const { default: WpPageTemplateReview } = await import('~/javascript/components/wp_page_templates/review.vue')

    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = 'none'
    }

    const props = {
      templateId: this.templateIdValue,
      csrfToken: this.csrfTokenValue || document.querySelector('meta[name="csrf-token"]')?.content
    }

    this.vueApp = createApp(WpPageTemplateReview, props)
    this.vueApp.mount(this.element)
  }

  unmountVue() {
    if (this.vueApp) {
      this.vueApp.unmount()
      this.vueApp = null
    }
  }
}
